import { addThunk } from 'actions/userNotifications/userNotificationActions';
import { useAuth } from 'hooks';
import { OnboardingSteps as OnboardingStepsModel } from 'model/OnboardingSteps';
import { UserNofiticationsWebSocketsMessage } from 'model/WebSockets';
import { FunctionComponent, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { debugConsoleLog } from 'utils/GeneralUtils';
import { websocketLog } from './websocketLog';
import { useActionCableChannel } from './useActionCableChannel';

const notificationsEnabled = process.env.REACT_APP_NOTIFICATIONS_ENABLED?.toLowerCase() === 'true';

const UserNotificationsWebSockets: FunctionComponent = () => {
    const auth = useAuth();
    const dispatch = useDispatch();
    const onBoardingProgress = useSelector<RootState, OnboardingStepsModel>(
        state => state.onboardingSteps.onboardingSteps
    );

    const isOnBoardingCompleted = useMemo(
        () =>
            onBoardingProgress.businessHoursDone &&
            onBoardingProgress.teamDone &&
            onBoardingProgress.petTypesDone &&
            onBoardingProgress.servicesDone &&
            onBoardingProgress.clientsDone &&
            onBoardingProgress.bookingDone,
        [onBoardingProgress]
    );

    const onReceived = useCallback(
        (message: UserNofiticationsWebSocketsMessage) => {
            if (message.notification && message.notification_receipt) {
                websocketLog('message', 'UserNotificationsWebSockets', {
                    notificationId: message.notification.id
                });

                const receipt = {
                    ...message.notification_receipt,
                    notification_type_id: message.notification.type_id,
                    notification_body: message.notification.body,
                    notification_subject: message.notification.subject,
                    source: message.notification.source ?? message.notification_receipt.source,
                    status: message.notification.status ?? message.notification_receipt.status,
                    target_id: message.notification.target_id,
                    target_type: message.notification.target_type,
                    target_status: message.notification.target_status
                };
                dispatch(addThunk(receipt));
            } else {
                debugConsoleLog('Incorrect notifications format: ' + JSON.stringify(message));
            }
        },
        [dispatch]
    );

    useActionCableChannel<UserNofiticationsWebSocketsMessage>({
        channel: 'NotificationsChannel',
        params: {
            marketplace_id: auth.marketplaceId,
            staff_id: auth.user?.staffId
        },
        enabled: Boolean(
            auth.signedIn && auth.marketplaceId && auth.user?.staffId && isOnBoardingCompleted && notificationsEnabled
        ),
        onReceived,
        subscriptionDeps: [auth.marketplaceId, auth.user?.staffId, isOnBoardingCompleted],
        logLabel: 'UserNotificationsWebSockets'
    });

    return null;
};

export default UserNotificationsWebSockets;
